var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"text-center",attrs:{"custom-class":"max-w-md","cancel-button-text":"Close"},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('h3',{domProps:{"textContent":_vm._s(_vm.$t('FREDDIES_AMERALLY_OPTOUT'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }